<script setup lang="ts">
import { HomePage } from '@features/home'
</script>

<template>
  <home-page />
</template>
